import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

export interface IBankTypeFormMeta {
    myId: FormInputMeta;
    name: FormInputMeta;
    initials: FormInputMeta;
    schema: any;
  }

const BankTypeFormMeta = {} as IBankTypeFormMeta;

BankTypeFormMeta.myId = {
    name: "myId",
    label: "ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
BankTypeFormMeta.name = {
    name: "name",
    label: "Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}


BankTypeFormMeta.schema = yup.object().shape(getValidationSchema(BankTypeFormMeta));

export default BankTypeFormMeta;